'use client'

import { HeartFilled16 } from '@vinted/monochrome-icons'
import { Icon, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  InfluencerProductCardModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const NewProductCard = ({
  title,
  thumbnailUrl,
  productUrl,
  testId,
}: InfluencerProductCardModel) => {
  const { track } = useTracking()

  const handleCardClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.ProductCardClick,
        targetDetails: productUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <article className="influencer-v2__product-card">
      <a href={productUrl} onClick={handleCardClick}>
        <div className="influencer-v2__product-card-image">
          {thumbnailUrl && (
            <Image src={thumbnailUrl} loading="lazy" scaling="cover" testId={testId} />
          )}
          <div className="influencer-v2__fave-icon">
            <Icon name={HeartFilled16} color="warning-medium" />
          </div>
        </div>
        <h3 className="influencer-v2__product-card-title">{title}</h3>
      </a>
    </article>
  )
}

export default NewProductCard
